import React, { useEffect } from 'react';
import { useClarityPageView } from "../utlis/useClarityPageView";     
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../helper/functions';
import HomePage from '../../components/pages/HomePage';
import Layout from '../../components/layout';
import IosPage from '../../components/pages/IosPage';
import AndroidPage from '../../components/pages/AndroidPage';
import EnterprisePage from '../../components/pages/EnterprisePage';
import AppSupportPage from '../../components/pages/AppSupportPage';
import ServicePage from '../../components/pages/ServicePage';
import HealthCarePage from '../../components/pages/HealthCarePage';
import AIHealthcarePage from '../../components/pages/AIHealthcarePage';
import AIBusinessPage from '../../components/pages/AIBusinessPage';
import ECommercePage from '../../components/pages/ECommercePage';
import WebAppPage from '../../components/pages/WebAppPage';
import WordPress from '../../components/pages/WordPress';
import WebsiteSupportPage from '../../components/pages/WebsiteSupportPage';
import HospitalDashPage from '../../components/pages/HospitalDashPage';
import HospitalIntranetPage from '../../components/pages/HospitalIntranetPage';
import CareerPage from '../../components/pages/CareerPage';
import AboutUsPage from '../../components/pages/AboutUsPage';
import EPDSystemPage from '../../components/pages/EPDSystemPage';
import ERPSoftwareDevPage from '../../components/pages/ERPSoftwareDevPage';
import SaaSDevPage from '../../components/pages/SaaSDevPage';
import CRMDevPage from '../../components/pages/CRMDevPage';
import ECCPage from '../../components/pages/ECCPage';
import MoodyMonthPage from '../../components/pages/MoodyMonthPage';
import AIChatPage from '../../components/pages/AIChatPage';
import BitEuPage from '../../components/pages/BitEuPage';
import LoginPage from '../../components/pages/LoginPage';
import DashboardPage from '../../components/pages/DashboardPage';
import ProtectedRoute from './ProtectedRoute';
import EditBlog from '../../components/molecules/DashboardComponents/blog/EditBlog';
import LoadingScreen from '../../components/atoms/LoadingScreen/LoadingScreen';
import BlogPage from '../../components/pages/BlogPage';
import ContactUSPage from '../../components/pages/ContactUSPage';
import MoodyMonthAppPage from '../../components/pages/MoodyMonthAppPage';
import ECCAppPage from '../../components/pages/ECCAppPage';
import BitEuWebPage from '../../components/pages/BitEuWebPage';
import EditJobPost from '../../components/molecules/DashboardComponents/jobPost/EditJobPost';
import BlogDetailsPage from '../../components/pages/BlogDetailsPage';
import ApplyForm from '../../components/molecules/CareerComponents/ApplyForm/ApplyForm';
import PortfolioPage from '../../components/pages/PortfolioPage';
import StoryMagic from '../../components/pages/StoryMagic';
import GalleryPage from '../../components/pages/GalleryPage';
import AIDoctorPage from '../../components/pages/AIDoctorPage';
import QuivverPage from '../../components/pages/QuivverPage';
import BookPage from '../../components/pages/BookPage';
import CryonePage from '../../components/pages/CryonePage';

const AppRoutes = () => {
      useClarityPageView();
    const { loading } = useData()
    return (
        <>
            {!loading ? <div className=''>
                <Routes>
                    {/* Public Routes */}
                    <Route path='/login' element={<LoginPage />} />

                    {/* Protected Dashboard Routes */}
                    <Route element={<ProtectedRoute />}>
                        <Route path='/dashboard' element={<DashboardPage />} />
                        <Route path='/edit-blog/:id' element={<EditBlog />} />
                        <Route path='/edit-job/:id' element={<EditJobPost />} />

                    </Route>

                    {/* Standalone Pages (no header/footer) */}
                    <Route path='book' element={<BookPage />} />

                    {/* Regular Routes */}
                    <Route path='/' element={<Layout />}>
                        <Route path="" element={<HomePage />} />
                        <Route path="ios" element={<IosPage />} />
                        <Route path="android" element={<AndroidPage />} />
                        <Route path="enterprise" element={<EnterprisePage />} />
                        <Route path="appsupport" element={<AppSupportPage />} />
                        <Route path="service" element={<ServicePage />} />
                        <Route path="healthcare" element={<HealthCarePage />} />
                        <Route path="aibusiness" element={<AIBusinessPage />} />
                        <Route path="aihealthcare" element={<AIHealthcarePage />} />
                        <Route path="ecommerce" element={<ECommercePage />} />
                        <Route path="webapp" element={<WebAppPage />} />
                        <Route path="wordpress" element={<WordPress />} />
                        <Route path="websitesupport" element={<WebsiteSupportPage />} />
                        <Route path="hospitaldashboard" element={<HospitalDashPage />} />
                        <Route path="hospitalintranet" element={<HospitalIntranetPage />} />
                        <Route path="career" element={<CareerPage />} />
                        <Route path='aboutus' element={<AboutUsPage />} />
                        <Route path='gallery' element={<GalleryPage />} />
                        <Route path='epdsystem' element={<EPDSystemPage />} />
                        <Route path='erpsoftware' element={<ERPSoftwareDevPage />} />
                        <Route path='saasdev' element={<SaaSDevPage />} />
                        <Route path='crmdev' element={<CRMDevPage />} />
                        <Route path='ecc' element={<ECCPage />} />
                        <Route path='eccapp' element={<ECCAppPage />} />
                        <Route path='moodymonth' element={<MoodyMonthPage />} />
                        <Route path='moodymonthapp' element={<MoodyMonthAppPage />} />
                        <Route path='aichat' element={<AIChatPage />} />
                        <Route path='aidoctor' element={<AIDoctorPage />} />
                        <Route path='biteu' element={<BitEuPage />} />
                        <Route path='biteuweb' element={<BitEuWebPage />} />
                        <Route path='tournamentapp' element={<QuivverPage />} />
                        <Route path='cryone' element={<CryonePage />} />
                        <Route path='storymagic' element={<StoryMagic />} />
                        <Route path='blog' element={<BlogPage />} />
                        <Route path="portfolio" element={<PortfolioPage />} />
                        <Route path='blog/:id' element={<BlogDetailsPage />} />
                        <Route path='contactus' element={<ContactUSPage />} />
                        <Route path='apply' element={<ApplyForm />} />
                        <Route path='*' element={<Navigate to='/' />} />
                    </Route>
                </Routes>
            </div> : <LoadingScreen />}
        </>
    );
};

export default AppRoutes;
